module.exports = __webpack_public_path__ + "static/media/m_eyeshape_downturned_amber.407ed0ac.png";